<template>
  <div
    class="align-center bg- flex !h-screen !w-screen items-center justify-center bg-[linear-gradient(33deg,rgba(26,174,232,1)_0%,rgba(109,197,232,1)_50%,rgba(207,240,255,1)_100%)] dark:[background-image:linear-gradient(33deg,#0f172a_0%,#1e293b_50%,#0f172a_100%)]"
  >
    <div
      class="h-fit w-11/12 rounded-xl bg-[rgba(255,255,255,0.5)] p-8 shadow backdrop-blur-md dark:bg-slate-900/85 sm:w-10/12 md:w-[420px] md:p-12"
    >
      <div class="mb-4 flex items-center justify-center gap-4">
        <img src="@/assets/open-mdx.png" alt="logo openmdx" class="h-18 w-auto" />
      </div>

      <Tag
        severity="warn"
        :value="languageStore.t('auth.login.associateWarn')"
        class="mt-4 w-full"
      />

      <div class="py-4 text-sky-900 dark:text-slate-50">
        <label class="mb-2 block font-bold">{{ languageStore.t('auth.login.emailLabel') }}</label>
        <InputText
          id="email"
          type="text"
          :placeholder="languageStore.t('auth.login.placeholders.email')"
          @keydown.enter="loginAd"
          v-model="form.email"
          :class="{ 'p-invalid': errors.email }"
          class="w-full"
        />
        <small v-if="errors.email" class="text-red-500">{{ errors.email }}</small>
      </div>
      <Button
        :label="languageStore.t('auth.login.associate')"
        class="mb-2 w-full"
        @click="loginAd"
        :loading="isLoading"
      />
      <Tag severity="danger" :value="errorMessage" v-if="errorMessage" class="mt-4 w-full" />
      <div class="mt-4 flex flex-col items-center justify-center gap-4">
        <img src="@/assets/logo-nepen.png" alt="logo nepen" class="h-8 w-auto" />
        <SelectLanguage />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import SelectLanguage from '@/components/subcomponents/SelectLanguage.vue'
import * as loginServices from '@/services/userService'
import { useLanguageStore } from '@/stores/LanguageStore'
import { useAssociateValidator } from '@/validators/associateAccountValidator'
import { useToast } from 'primevue'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Tag from 'primevue/tag'
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'

const languageStore = useLanguageStore()
const toast = useToast()
const router = useRouter()

const { createForm, createEmptyErrors, validateForm } = useAssociateValidator()

const form = reactive(createForm())
const errors = reactive(createEmptyErrors())
const isLoading = ref(false)
const errorMessage = ref('')

const loginAd = () => {
  console.log(history.state)
  const validation = validateForm(form)
  if (!validation.isValid) {
    Object.assign(errors, validation.errors)
    return
  }

  isLoading.value = true
  errorMessage.value = ''

  loginServices
    .loginAd(history.state?.email, history.state?.password, form.email)
    .then((res) => {
      const access = loginServices.auth(router, res.data.accessToken, res.data.user)
      if (!access) {
        errorMessage.value = 'Usuário não tem acesso a esta aplicação'
      }
    })
    .catch((error) => {
      errorMessage.value = error?.response?.data?.detail
      if (errorMessage.value === 'UserNotAssociated') {
        router.push('/')
      }

      toast.add({
        summary: 'Erro',
        detail: errorMessage.value || 'Erro ao fazer login',
        severity: 'error',
        life: 3000,
      })
    })
    .finally(() => {
      isLoading.value = false
    })
}
</script>
